<template>
  <div>
    <div>
      <span class="font-weight-bold">{{ $t("diaries.comment") }}:</span>
      <p class="pre-formatted">{{ pefDiary.comment | capitalize }}</p>
    </div>
    <div>
      <span class="font-weight-bold">{{ $t("diaries.learning") }}:</span>
      <p class="pre-formatted">{{ pefDiary.learning | capitalize }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PefDiary",
  props: {
    pefDiary: {
      type: Object,
    },
  },
}
</script>
